<div class="ab-list-item-inner flex w-100 activity-type--note">
    <span class="ab-list-item__icon">
        <i class="icon fal fa-sticky-note"></i>
    </span>
    <div class="ab-list-item__content">
        <div class="summary">
            <span class="actor">{{item?.user?.name}}</span> added a note to
            <app-activity-target-link [target]="item.target">{{item?.target | fullName}}'s</app-activity-target-link>
            profile:
        </div>
        <div class="details">
            <em class="note--clipped"
                [ngClass]="{'d-none': showFullText}"
                [innerHtml]="item?.payload?.note?.text | truncateText:75 | escapedHtml | autolinker"
                ></em>
            <span class="note--expanded"
                  [ngClass]="{'d-none': !showFullText}"
                  [innerHtml]="item?.payload?.note?.text | escapedHtml | autolinker"
                  ></span>
            <span class="meta ml-0025"
                  [ngClass]="{'d-none': showFullText || item?.payload?.note?.text.length < 76}">(<button type="button"
                        class="note--show-hide-toggle"
                        (click)="setShowFullText(true)">show more</button>)</span>
        </div>
    </div>
    <app-activity-event-timestamp [item]="item"
                                  class="ab-list-item__timestamp">
    </app-activity-event-timestamp>
</div>
